import { h, type VNode } from 'vue'
import AvatarImg from './AvatarImg.vue'
import { getImgUrl, getNumberFromUrl } from '../../utils/getImgUrl'

// 把后端下发的 avatar 字段（可能是空/纯数字/预签名 URL）统一解析成 AvatarImg 需要的完整图片 URL。
// AvatarImg 的模板是 `<img :src="avatar" />`，src 必须是可直接加载的 URL，不能是 "avatar-3" 之类的字符串。
// 三种输入：
//   1) null / 空          → 兜底内置头像 avatar-1
//   2) URL 且路径最后一段是短字符串（<8）→ 走内置头像 avatar-N（S3 预签名的默认头像形态：/3?...）
//   3) URL 但最后一段较长 → 用户上传的真实图片，原样返回
// 判定逻辑与 ChannelAvatar 保持一致（getNumberFromUrl），避免两处漂移。
export const resolveAvatar = (id: string | null | undefined): VNode => {
  if (id == null || id === '') {
    return h(AvatarImg, { avatar: getImgUrl('avatar/avatar-1', 'png') })
  }
  return h(AvatarImg, { avatar: getNumberFromUrl(id) })
}
